import styled from "styled-components";

export const StyledCustomPrices = styled.div`
    display: flex;
    gap: 0.6rem;
    align-items: center;
    font-size: 1.1rem;
`